import { useAppSelector } from 'hooks/useAppSelector';
import { getOrdersBasketTotalNumberOfForms } from 'state/selectors';

export const OrdersBasketFormCount = () => {
  const nbForms = useAppSelector(getOrdersBasketTotalNumberOfForms);

  if (nbForms <= 0) {
    return null;
  }
  return (
    <span className="badge rounded-pill badge-info align-middle ms-2" data-e2e="central-station-orders-basket-count">
      {nbForms}
    </span>
  );
};
